import {ReactNode} from "react";

export type PageAction<Context> = {
    type: 'toolbar-item',
    component: (context: Context, actionHandler: () => void) => ReactNode,
} | {
    type: 'menu-item',
    component: (context: Context, actionHandler: () => void) => ReactNode,
};

export class PageActionHandler<Action extends string> {
    private handlers = new Map<Action, () => void>();

    setHandler(action: Action, handler: () => void): () => void {
        this.handlers.set(action, handler);
        return () => this.handlers.delete(action);
    }

    trigger(action: Action) {
        this.handlers.get(action)?.();
    }
}

export function usePageActionHandler(): PageActionHandler<any> {
    return new PageActionHandler<any>();
}